import React from 'react';
import { lifestyleImage } from '../data/content';
export function Problem() {
  return <section className="border-y border-ink/10 bg-sand/60" data-id="element-157" data-mp="2pf8teiccqprr">
      <div className="mx-auto grid max-w-6xl gap-12 px-6 py-16 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16 lg:py-24" data-id="element-158" data-mp="2pdefhnzhzxx6">
        <div className="order-2 lg:order-1" data-id="element-159" data-mp="2bi27iewc0ayb">
          <img src={lifestyleImage} alt="Mujer de pie junto a una ventana con luz natural, con las manos relajadas sobre su abdomen" className="w-full rounded-[2rem] object-cover" loading="lazy" data-id="element-160" data-mp="2gdrdazyy2o32" />
        </div>

        <div className="order-1 lg:order-2" data-id="element-161" data-mp="1sphv080xwigo">
          <p className="font-display text-2xl font-semibold leading-snug text-teal-deep sm:text-3xl" data-id="element-162" data-mp="1sqszka27lu8u">
            ¿Te ha pasado que despiertas con el vientre plano, pero después del
            almuerzo sientes que el botón de tu pantalón está a punto de salir
            disparado?
          </p>
          <p className="mt-6 max-w-prose text-lg leading-relaxed text-ink/75" data-id="element-163" data-mp="1noty55q157ej">
            No es solo el exceso de comida: es tu cuerpo gritando por ayuda. La
            mayoría de las mujeres entre 25 y 45 años viven con una inflamación
            crónica que no se quita con abdominales ni con dietas extremas de
            lechuga y agua.
          </p>

          <hr className="my-10 w-16 border-t-2 border-gold" data-id="element-164" data-mp="xb0j5v7fc854" />

          <p className="max-w-prose text-base leading-relaxed text-ink/75" data-id="element-165" data-mp="x9fmo01juf4m">
            Vives cansada de probar suplementos "mágicos", batidos verdes que te
            hinchan más y rutinas de ejercicio que solo elevan tu estrés. La
            realidad es que tu "guatita" no es solo grasa: es el resultado de un
            sistema digestivo saturado y niveles de cortisol por las nubes.
          </p>
          <p className="mt-5 max-w-prose text-base leading-relaxed text-ink/75" data-id="element-166" data-mp="ej7przog0kwv">
            Esa pesadez después de comer, el cansancio mental y la ropa que te
            queda perfecta en la mañana pero insoportable en la tarde tienen una
            raíz clara:{' '}
            <strong className="font-semibold text-ink" data-id="element-167" data-mp="1ly3b0chu2y6s">
              inflamación intestinal
            </strong>
            .
          </p>
        </div>
      </div>
    </section>;
}